export interface ReportsFilter {
  year?: number;
  month?: number;
}

export interface ReportsOptions {
  allCheckbox: boolean;
  checkboxes: ReportsCheckboxes;
}

export interface Checkbox {
  key: string;
  tooltip: string;
  title: string;
  disabled: boolean;
}

export interface ReportsCheckboxes {
  financialMarketsUpdate: boolean;
  performanceCommentary: boolean;
  portfolio: boolean;
  extendedReturns: boolean;
  totalReturns: boolean;
  excessBefore: boolean;
  excessAfter: boolean;
}

export const CHECKBOX_INFO = {
  financialMarketsUpdate: {
    title: 'Financial Markets Update'
  },
  performanceCommentary: {
    title: 'Performance Commentary'
  },
  portfolio: {
    title: 'Portfolio And Asset Allocation'
  },
  extendedReturns: {
    title: 'Extended Returns'
  },
  totalReturns: {
    title: 'Total Returns - After Fees'
  },
  excessBefore: {
    title: 'Excess Returns - Before Fees'
  },
  excessAfter: {
    title: 'Excess Returns - After Fees'
  }
};

/**
 * These values are used to request reports download from back-end, as well as for selecting tooltip values from notes state
 */
export enum ApiTypeKeys {
  financialMarketsUpdate = 'financial-markets-update',
  performanceCommentary = 'performance-commentary',
  portfolio = 'allocations',
  extendedReturns = 'extended-returns',
  totalReturns = 'net-returns',
  excessBefore = 'excess-gross-returns',
  excessAfter = 'excess-net-returns'
}

// allocations:
// excess-gross-returns:
// excess-net-returns:
// extended-returns:
// net-returns

export interface ReportsDownloadRequestPayload {
  account: string;
  date: string;
  type: string;
  country: string;
}

export interface ReportsExcelDownloadRequestPayload {
  type: string;
  from: string;
  to: string;
  id: string;
  userDate: string;
}

export interface ReportsAvailability {
  type: string;
  available: boolean;
}

export interface ReportsAvailabilityRequest {
  account: string;
  date: string;
}
